window.isProgress = true
window.isShowIntercept = true

import axios from 'axios'

setAxios() // 设置axios

// axios 配置
function setAxios() {
  axios.interceptors.request.use(
    (request) => {
      if (window.isProgress) window.app.$insProgress.start()
      window.isProgress = true
      request.headers.Authorization = 'Bearer ' + window.app.$cookies.get('token')
      return request
    },
    (err) => {
      return Promise.reject(err)
    },
  )

  axios.interceptors.response.use(
    (response) => {
      window.app.$insProgress.finish()
      if (response.status == 200) {
        //服务端 返回错误信息
        if (response.data.status >= 1000 && response.data.status < 2000 && response.data.msg) {
          window.app.$alert.warning(response.data.msg)
        }
        if (typeof response.data == 'string' && (response.data.indexOf('<!DOCTYPE html>') > 0 || response.data == 'nosession')) {
          console.log('************认证失败=>登录', response.data)
          console.log('退出', response)
          if (window.config.showExitLoginAlert()) {
            window.alert('退出到登录页，如果异常退出，请保持页面不动，联系开发人员')
          }
          // location.href = '/';
          // window.app.$api.sso()
          // window.app.$store.commit('logout');
          return
        }
        return response
      }
      if (response.status == 401) {
        if (window.config.showExitLoginAlert()) {
          window.alert('退出到登录页，如果异常退出，请保持页面不动，联系开发人员')
        }
        //if (process.env.NODE_ENV != 'development') {
        window.app.$message.error('未授权，请重新登录')
        location.href = '/'
        //  }
      }
      if (response.status == 302) {
        window.location.href = response.data
        //window.location.href = response.data.redirectUrl; //重定向
      } else {
        window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
      }
    },
    (error) => {
      // window.app.$insProgress.finish();
      //显示拦截信息
      if (window.isShowIntercept) {
        if (error.response) {
          switch (error.response.status) {
            case 302:
              window.location.href = error.response.data
              break
            case 400:
              window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
              break
            case 401:
              console.log(error)
              location.href = '/'
              window.app.$alert.error('未授权，请登录～')
              console.log('退出', error, error.response)

              if (window.config.showExitLoginAlert()) {
                window.alert('退出到登录页，如果异常退出，请保持页面不动，联系开发人员' + JSON.stringify(error))
              }
              if (process.env.NODE_ENV != 'development') {
                // location.href = '/'
                //window.app.$api.jumpOut();
                // window.app.$api.sso()
              }
              break
            case 403:
              window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
              break
            case 404:
              window.app.$alert.error('服务地址不存在，请联系管理人员')
              break
            case 504:
              window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
              break
            case 500:
              window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
              break
          }
        } else {
          window.app.$alert.error('哎呀网络连接不畅，请刷新重试～')
        }
      }

      window.isShowIntercept = true
      //中止promise链
      // return new Promise(() => {});
    },
  )
}

function getParamData(data) {
  if (data) {
    data.params = {
      ...data,
    }
  }
  return data
}

const http = {
  ...axios,
  // get,delete请求 加params
  get: (url, data) => {
    return axios.get(url, getParamData(data))
  },
  delete: (url, data) => {
    return axios.delete(url, getParamData(data))
  },
}

export default http
